module.exports = __webpack_public_path__ + "img/map_mobile_7.84d8b5a6.png";